import { VIEW_ACTION, EDIT_ACTION } from "constants/actions";

export const getModalHeader = (mode) => {
  let header = "Add Committee Assignment";

  if (mode === VIEW_ACTION) header = "View Committee Assignment";

  if (mode === EDIT_ACTION) header = "Edit Committee Assignment";

  return header;
};

const validateDuplicateCommittees = (validCommittees) => {
  const seenCombinations = new Set();

  const hasDuplicate = validCommittees.some((item) => {
    if (!item.committee || !item.position) {
      return false;
    }

    const combination = `${item.committee.value}-${item.position.value}`;

    if (seenCombinations.has(combination)) {
      return true;
    }

    seenCombinations.add(combination);

    return false;
  });

  return hasDuplicate;
};

export const validateCommitteeForm = (
  formHouseMember,
  formRegion,
  formAffiliation,
  validCommittees
) => {
  if (!formHouseMember) {
    return "Please select a House Member";
  }

  if (!formRegion) {
    return "Please select a House Member to auto-fill Region";
  }

  if (!formAffiliation) {
    return "Please select a House Member to auto-fill Affiliation";
  }

  if (validCommittees.length === 0) {
    return "Please add at least one Committee with Position";
  }

  if (validateDuplicateCommittees(validCommittees)) {
    return "House Member can hold only one Position per Committee";
  }

  return true;
};
